import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Auth/Index.vue';

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? 'client-portal' : '/',
  routes: [
    {
      path: '/',
      name: 'auth:login',
      component: Login
    },
    {
      path: '/reset-password',
      name: 'auth:reset-password',

      component: () =>
        import(/* webpackChunkName: "NotFound" */ './views/Auth/ResetPassword.vue')
    },
    {
      path: '/oops',
      name: 'error',
      component: () =>
        import(/* webpackChunkName: "NotFound" */ './views/Oops.vue')
    },
    {
      path: '/applications',
      name: 'applications:list',
      component: () =>
        import(/* webpackChunkName: "ApplicationsList" */ './views/Applications/List.vue'),
      meta: { requiresAuth: true, layout: 'Admin' }
    },
    {
      path: '/conversations',
      name: 'conversations:list',
      component: () =>
        import(/* webpackChunkName: "Conversation" */ './views/Conversation.vue'),
      meta: { requiresAuth: true, layout: 'Admin' }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './views/Dashboard/Dashboard.vue'),
      meta: { requiresAuth: true, layout: 'Admin' }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () =>
        import(/* webpackChunkName: "Profile" */ './views/Profile.vue'),
      meta: { requiresAuth: true, layout: 'Admin' },
      children: [
        {
          path: '',
          name: 'profile:personal-information',
          component: () =>
            import(/* webpackChunkName: "PersonalInformation" */ './views/Profile/PersonalInformation.vue'),
          meta: { requiresAuth: true, layout: 'Admin' }
        },
        {
          path: 'education',
          name: 'profile:education-information',
          component: () =>
            import(/* webpackChunkName: "EducationInformation" */ './views/Profile/EducationInformation.vue'),
          meta: { requiresAuth: true, layout: 'Admin' }
        },
        {
          path: 'change-password',
          name: 'profile:change-password',
          component: () =>
            import(/* webpackChunkName: "ApplicationsList" */ './views/Profile/ChangePassword.vue'),
          meta: { requiresAuth: true, layout: 'Admin' }
        },
        {
          path: '*',
          redirect: '/notFound'
        }
      ]
    },
    {
      path: '*',
      component: () =>
        import(/* webpackChunkName: "NotFound" */ './views/NotFound.vue')
    }
  ]
});
